import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaHome, FaUsers, FaGavel, FaChartLine, FaCog, FaSignOutAlt, FaRegCommentDots, FaEnvelopeOpenText } from "react-icons/fa";
import "./Dashboard.css";
import { HerracContext } from "../../App";
import axios from "axios";

const Sidebar = () => {
    const navigate = useNavigate();
    const { setUser } = useContext(HerracContext); // İstifadəçi məlumatlarını yeniləmək üçün kontekstdən istifadə edirik

    // 🔹 **Çıxış funksiyası**
    const handleLogout = async () => {
        try {
            await axios.post('https://api.herracim.az/api/account/logout', {}, {
                withCredentials: true
            });
            setUser(null);
            window.location.reload(); // və ya navigate("/")
        } catch (error) {
            console.error("Çıxış zamanı xəta:", error);
        }
    };
    return (
        <div className="sidebar">
            <div className="sidebar-logo">
                <h2>Herrac Dashboard</h2>
            </div>
            <ul className="sidebar-menu">
                <li>
                    <Link to="/dashboard">
                        <FaHome /> Ana Səhifə
                    </Link>
                </li>
                <li>
                    <Link to="/dashboard/users">
                        <FaUsers /> İstifadəçilər
                    </Link>
                </li>
                <li>
                    <Link to="/dashboard/auctions">
                        <FaGavel /> Hərraclar
                    </Link>
                </li>
                <li>
                    <Link to="/dashboard/deposit-stats">
                        <FaChartLine />Depozit Statistikası
                    </Link>
                </li>
                <li>
                    <Link to="/dashboard/send-notification">
                        <FaEnvelopeOpenText /> İstifadəçilərə mesaj
                    </Link>
                </li>
                <li>
                    <Link to="/dashboard/complaint-details">
                        <FaRegCommentDots /> Şikayət Detalları
                    </Link>
                </li>
                <li>
                    <Link to="/dashboard/settings">
                        <FaCog /> Parametrlər
                    </Link>
                </li>
                <li className="logout">
                    <button onClick={handleLogout} className="logout-btn">
                        <FaSignOutAlt /> Çıxış
                    </button>
                </li>

            </ul>
        </div>
    );
};

export default Sidebar;
